import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { X } from 'lucide-react';

const AddToVivierModal = ({ isOpen, onClose, onConfirm, candidatureName }) => {
  const [commentaire, setCommentaire] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(commentaire.trim());
    setCommentaire('');
    onClose();
  };

  const handleCancel = () => {
    setCommentaire('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <Card className="add-to-vivier-modal">
        <CardContent className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">
              Ajouter au vivier des candidatures
            </h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleCancel}
              className="p-1 h-8 w-8"
            >
              <X size={16} />
            </Button>
          </div>

          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-3">
              Vous êtes sur le point d'ajouter <strong>{candidatureName}</strong> au vivier des candidatures.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="commentaire" className="block text-sm font-medium text-gray-700 mb-2">
                Commentaire (optionnel)
              </label>
              <textarea
                id="commentaire"
                value={commentaire}
                onChange={(e) => setCommentaire(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                rows="3"
                placeholder="Ajoutez un commentaire sur cette candidature..."
              />
            </div>

            <div className="flex justify-end space-x-3">
              <Button
                type="button"
                variant="outline"
                onClick={handleCancel}
                className="px-4 py-2"
              >
                Annuler
              </Button>
              <Button
                type="submit"
                className="btn-primary px-4 py-2"
                style={{ backgroundColor: '#eb5d2d', borderColor: '#eb5d2d' }}
              >
                Ajouter au vivier
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AddToVivierModal;